export const PageHero = ({ eyebrow, title, copy, image, children }) => (
  <section className="page-hero">
    <div className="wrap page-hero-inner">
      <div className="reveal">
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p>{copy}</p>
        {children}
      </div>
      {image && <img src={image} alt="ML FAB emergency vehicle" />}
    </div>
  </section>
);
